import React, { useEffect, useState } from 'react';

import { useDataContext } from 'src/context/data';

import Conversation from './Conversation/Conversation';
import Launcher from './Launcher/Launcher';

import { COOKIE_CONSENT_CUSTOM_EVENT_NAME, checkCookieBannerIsOpen } from 'src/utils/cookieBanners';

/* - - - - - - - - - - - - - - - - - - - - - - - */

function Widget() {
  const {
    makeWidgetInit,
    appState: { widgetData, currentMessageId, widgetIsOpen },
  } = useDataContext();

  const [isCookieBannerOpen, setIsCookieBannerOpen] = useState(false);

  useEffect(() => {
    makeWidgetInit();
  }, []);

  useEffect(() => {
    setIsCookieBannerOpen(checkCookieBannerIsOpen());
  }, [widgetIsOpen]);

  useEffect(() => {
    const handleConsentUpdate = () => {
      setTimeout(() => {
        setIsCookieBannerOpen(checkCookieBannerIsOpen());
      }, 1000);
    };

    document.addEventListener(COOKIE_CONSENT_CUSTOM_EVENT_NAME, handleConsentUpdate);
    return () => {
      document.removeEventListener(COOKIE_CONSENT_CUSTOM_EVENT_NAME, handleConsentUpdate);
    };
  }, []);

  const renderRoot = () => {
    if (!widgetData || !currentMessageId) return <div />;

    return (
      <div className="rcw-widget-container" style={{ zIndex: widgetIsOpen && !isCookieBannerOpen ? 999999 : 9990 }}>
        {widgetIsOpen && <Conversation />}
        <Launcher />
      </div>
    );
  };

  return renderRoot();
}

export default Widget;
